import { handleResetSegment } from 'core/utils/segment/useSegmentTracking';
import type { LoginError, Oauth2TokenResponse, PermissionFlags, User } from './auth.models';

export const AuthActionsTypes = {
  LOGIN_REQUEST: '[Auth Service] Request Login',
  LOGIN_SUCCESS: '[Auth Service] Login Success',
  LOGIN_FAILURE: '[Auth Service] Login Failure',

  LOGOUT_REQUEST: '[Auth Service] Logout Request',
  LOGOUT_SUCCESS: '[Auth Service] Logout Success',
  LOGOUT_FAILURE: '[Auth Service] Logout Failure',

  LOAD_LICENSING_STATUS: '[Auth Service] Load Licensing Status',
  LOAD_LICENSING_STATUS_SUCCESS: '[Auth Service] Load Licensing Status Success',
  LOAD_LICENSING_STATUS_FAILURE: '[Auth Service] Load Licensing Status Failure',

  LOAD_CURRENT_USER_SUCCESS: '[Auth Service] Load Current User Success',
  LOAD_CURRENT_USER_FAILURE: '[Auth Service] Load Current User Failure',
  LOAD_CURRENT_USER_ACCOUNT_SERVICE: '[Auth Service] Load Current User Account Service Success',

  SET_PERMISSION_FLAGS: '[Auth Service] Set Permission Flags'
};

export const LoginRequest = (code: string) => {
  return {
    type: AuthActionsTypes.LOGIN_REQUEST,
    payload: code
  };
};

export const LoginSuccess = (token: Oauth2TokenResponse) => {
  return {
    type: AuthActionsTypes.LOGIN_SUCCESS,
    payload: token
  };
};

export const LoginFailure = (error: LoginError) => {
  return {
    type: AuthActionsTypes.LOGIN_FAILURE,
    payload: error
  };
};

export const LogoutRequest = () => {
  return {
    type: AuthActionsTypes.LOGOUT_REQUEST
  };
};

export const LogoutSuccess = () => {
  sessionStorage.clear();
  handleResetSegment();
  return {
    type: AuthActionsTypes.LOGOUT_SUCCESS
  };
};

export const LogoutFailure = (error: LoginError) => {
  return {
    type: AuthActionsTypes.LOGOUT_FAILURE,
    payload: error
  };
};

export const LoadCurrentUserSuccess = (user: User) => {
  return {
    type: AuthActionsTypes.LOAD_CURRENT_USER_SUCCESS,
    payload: user
  };
};

export const LoadCurrentUserAccountService = (isUserAccountService: boolean) => {
  return {
    type: AuthActionsTypes.LOAD_CURRENT_USER_ACCOUNT_SERVICE,
    payload: isUserAccountService
  };
};

export const LoadCurrentUserFailure = () => {
  return {
    type: AuthActionsTypes.LOAD_CURRENT_USER_FAILURE
  };
};

export const SetPermissionFlags = (permissionFlags: PermissionFlags) => {
  return {
    type: AuthActionsTypes.SET_PERMISSION_FLAGS,
    payload: permissionFlags
  };
};
